import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Field} from '../../model/field.model';
import {Line} from '../../model/line.model';
import {Tree} from '../../model/tree.model';
import {StateService} from '../../state.service';
import {TruffleFound} from '../../model/truffelFound.model';
import {calculateYearlyYield, inferStartYear, YearlyYield} from '../../utils/yield.utils';

@Component({
    selector: 'app-line',
    templateUrl: './line.component.html',
    styleUrls: ['./line.component.css'],
    standalone: false
})
export class LineComponent {
  fieldId: string;
  field: Field;

  constructor(private route: ActivatedRoute, private router: Router, private stateService: StateService) {
    this.route.paramMap.subscribe(params => {
      this.fieldId = params.get('fieldId');
      stateService.getField(this.fieldId).subscribe(field => {
        this.field = field;
      });
    });
  }

  addLine() {
    this.stateService.addLine();
  }

  deleteLine(line: Line) {
    if (line.trees.length > 0) {
      alert('Reihe kann nicht gelöscht wenn es Bäume hat');
    } else {
      const index: number = this.field.lines.indexOf(line);
      if (index !== -1) {
        this.field.lines.splice(index, 1);
        this.stateService.deleteLine(this.field);
      }
    }
  }

  getTotoalTruffel(trees: Tree[]) {
    let totalTruffel = 0;
    trees.forEach(t => {
      if (t.truffleFounds) {
        t.truffleFounds.forEach(f => {
          if (f.weight) {
            totalTruffel += f.weight;
          }
        });
      }
    });
    return totalTruffel;
  }

  getYearlyYieldForLine(line: Line): YearlyYield[] {
    const founds: TruffleFound[] = [];
    line.trees.forEach(tree => tree.truffleFounds?.forEach(found => founds.push(found)));

    let startYear: number | undefined = this.field ? inferStartYear(this.field.createdAt) : undefined;
    line.trees.forEach(tree => {
      const treeStart = inferStartYear(tree.createdAt, startYear, tree.truffleFounds);
      if (startYear === undefined || treeStart < startYear) {
        startYear = treeStart;
      }
    });

    const effectiveStart = startYear ?? new Date().getFullYear();
    return calculateYearlyYield(founds, effectiveStart);
  }
}
